import {
  IReservationCancelRequest,
  ReservationCancelResponse,
} from '@common/models';
import {
  AppointmentAuditLogModel,
  IAppointmentAuditLogModel,
} from '@common/models/AppointmentAuditLogModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from './serviceHelper';
import { ServiceMethodOptions } from './types';

export class ReservationService {
  // #region Private Variables
  private static baseUrl: string = '/api/reservation/';
  private static publicUserHeader: any = {
    vpca: '351BD313-2C19-442B-BC87-C69356EB59EF',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  };
  // #endregion

  static tags = {
    getAppointmentAuditLogs: 'getAppointmentAuditLogs',
  };

  /**
   * Confirms an appointment list
   * @param reservationPublicIds List of public reservation ids
   * @returns
   */
  static confirmBulk = (
    reservationPublicIds: string[],
    options?: ServiceMethodOptions,
  ): Promise<null> => {
    return trackPromise(
      new Promise<null>((resolve, reject) => {
        http(`${this.baseUrl}confirmbulk/`)
          .mergeOptions({ headers: this.publicUserHeader })
          .post<null>(reservationPublicIds)
          .then(() => {
            ServiceHelper.showSuccess('Appointments confirmed', options);
            resolve(null);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to confirm appointments', options);
            reject(err);
          });
      }),
    );
  };

  /**
   * Cancels an appointment list
   * @param reservationPublicIds List of public reservation ids
   * @param isReschedule Is Reservation list to be rescheduled
   * @param isRebook Is Reservation being rebooked
   * @returns
   */
  static cancelBulk = (
    request: IReservationCancelRequest,
    options?: ServiceMethodOptions,
  ): Promise<ReservationCancelResponse> => {
    return trackPromise(
      new Promise<ReservationCancelResponse>((resolve, reject) => {
        http(`${this.baseUrl}cancelBulk/`)
          .mergeOptions({ headers: this.publicUserHeader })
          .post<ReservationCancelResponse>(request)
          .then((response) => {
            ServiceHelper.showSuccess('Appointments cancelled', options);
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to cancel appointments', options);
            reject(err);
          });
      }),
    );
  };

  static getAppointmentAuditLogs = (
    reservationId: number,
    timezone?: string,
    options?: ServiceMethodOptions,
  ) =>
    trackPromise(
      new Promise<AppointmentAuditLogModel[]>((resolve, reject) =>
        http(`${this.baseUrl}${reservationId}/auditLogs`)
          .get<IAppointmentAuditLogModel[]>()
          .then((data) =>
            data.map((d) => new AppointmentAuditLogModel(d, timezone ?? 'utc')),
          )
          .then(resolve)
          .catch(reject),
      ),
      options?.promiseArea ?? this.tags.getAppointmentAuditLogs,
    );
}
